import React from "react";
import { QueryLoader } from "@jsq/ds/core";
import { useGetComplianceCaseQuery } from "~/graphql/supergraphHooks";
import { type GetComplianceCaseQuery } from "~/graphql/supergraphTypes";
import CurrentPaymentInstructions from "./CurrentPaymentInstructions";
import PositionsTable from "./PositionsTable";

interface Props {
  caseId: number;
  complianceCase: GetComplianceCaseQuery["complianceCase"] | undefined;
  readonly: boolean;
}

const PaymentInstructionChange = ({ caseId, complianceCase, readonly }: Props) => {
  const complianceCaseResult = useGetComplianceCaseQuery({
    variables: {
      caseId: caseId,
    },
  });

  return (
    <QueryLoader result={complianceCaseResult}>
      <CurrentPaymentInstructions complianceCase={complianceCase} />
      <PositionsTable readonly={readonly} caseId={caseId} complianceCase={complianceCase} />
    </QueryLoader>
  );
};

export default PaymentInstructionChange;
